<template>
  <div class="banner b1">
    <AdTip
      :tipClass="subscribeStatus === 2 ? 'blue' : ''"
      :viewDetail="subscribeStatus !== 2"
    />
    <div class="row1 sepTop">
      <div class="priceArea s8 c1">
        <div v-if="subscribeStatus === 1" class="t6">
          有效期至{{
            dayjs(resp.detail.detail.expireTime).format('YYYY-MM-DD')
          }}
        </div>
        <template v-else>
          <template v-if="videoType === 'shrink'">
            <div style="font-weight: bold">
              {{ displayPrice }}
            </div>
          </template>
          <template v-else>
            <div>
              ￥
            </div>
            <div style="font-weight: bold">
              {{ price }}
            </div>
            <div>
              /套
            </div>
            <div class="s4 t3 orignPrice">￥{{ originalPrice }}</div>
          </template>
        </template>
      </div>
      <div class="s8 t5 btn-buy" @click="goBuy">
        <span v-if="subscribeStatus === 1">续订</span>
        <span v-else-if="subscribeStatus === 2">再次订阅</span>
        <span v-else>立即订购</span>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import AdTip from '@/views/video/AdTip'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import Urls from '@/assets/js/Urls'
dayjs.extend(utc)
export default {
  name: 'PayBanner',
  props: ['subscribeStatus', 'videoType'],
  components: { AdTip },
  computed: {
    ...mapState('video', ['resp']),
    isLogin() {
      return this.$store.state.user.userInfo !== null
    },
    price() {
      return this.resp?.detail?.detail?.price || ''
    },
    displayPrice() {
      return this.resp?.detail?.detail?.displayPrice || ''
    },
    originalPrice() {
      return this.resp?.detail?.detail?.originalPrice || ''
    }
  },
  methods: {
    dayjs,
    goBuy() {
      if (!this.isLogin) {
        this.goLogin()
      } else {
        location.replace(
          `${Urls.DOMAIN_YOUKANTOUWAP}/ykt-cashier/?setId=${
            this.resp.detail.detail.goodsSetId
          }&redirectUrl=${encodeURIComponent(
            this.videoType === 'shrink'
              ? location.href
              : this.resp.detail.detail.payUrl
          )}`
        )
      }
    },
    goLogin() {
      let pathNames = location.pathname.split('/m/')
      let pathRouter = pathNames[pathNames.length - 1]
      this.$router.push({
        path: '/' + pathRouter + location.search,
        query: {
          needAuth: true
        }
      })
    }
  }
}
</script>

<style scoped>
.row1 {
  height: 98px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: #fff;
}

.banner {
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  background: #fff;
  bottom: constant(safe-area-inset-bottom); /* 兼容 iOS < 11.2 */
  bottom: env(safe-area-inset-bottom); /* 兼容 iOS >= 11.2 */
}

.btn-buy {
  width: 240px;
  height: 98px;
  background: #e64c2e;
  line-height: 98px;
  text-align: center;
  z-index: 100;
}

.orignPrice {
  text-decoration: line-through;
  margin-left: 10px;
}

.priceArea {
  margin-left: 30px;
  display: flex;
  flex-direction: row;
  align-items: baseline;
}
</style>
